var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoleicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C3.46957 0 2.96086 0.210714 2.58579 0.585786C2.21071 0.960859 2 1.46957 2 2C2 2.53043 2.21071 3.03914 2.58579 3.41421C2.96086 3.78929 3.46957 4 4 4C4.53043 4 5.03914 3.78929 5.41421 3.41421C5.78929 3.03914 6 2.53043 6 2C6 1.46957 5.78929 0.960859 5.41421 0.585786C5.03914 0.210714 4.53043 0 4 0ZM2 5C0.895 5 0 5.895 0 7V14H1V20H3V14H5V20H7V9V7H11V5H2ZM13 5V7H18V5H13ZM9 9V11H11V9H9ZM13 9V11H18V9H13ZM9 13V15H11V13H9ZM13 13V15H18V13H13ZM9 17V19H11V17H9ZM13 17V19H18V17H13Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleicon);
export default __webpack_public_path__ + "static/media/roleicon.0be6fd5739332a4b40204ecf9822e33a.svg";
export { ForwardRef as ReactComponent };